module.exports = __webpack_public_path__ + "a4d49b46ed75f2d30812ce83f7e05ece.png";